<template>
  <div class="set-scope">
    <select-scope
      v-loading="loading"
      multiple
      :var-group="userScopeVarGroup"
      @input="editControl.scope = $event"
      :value="editControl.scope.length > 0 ? editControl.scope : this.defaultScope"
      v-bind="scopeAttrs"
      :title="dialogTitle"
    ></select-scope>
  </div>
</template>
<script>
import SelectScope from "@/components/UIComponents/SelectScope"
import { getRoles } from "@/api/appManage/role"
import { getAllConnectedCompany, getCompanyConnectType } from "@/api/connect"

export default {
  name: "set-scope",
  components: {
    SelectScope
  },
  props: {
    editControl: Object, // editControl._type [staff,company]
    availableSheetMap: Object,
    sheet: Object
  },
  computed: {
    dialogTitle() {
      switch (this.editControl._type) {
        case "staff":
          return "选择人员范围"
        case "company":
          return "选择企业范围"
      }
      return "选择范围"
    },
    defaultScope() {
      return this.editControl._type === "staff"
        ? [{ label: "部门:全公司", type: "department", value: "1" }]
        : [{ label: "企业:所有企业", type: "company", value: "1" }]
    },
    scopeAttrs() {
      switch (this.editControl._type) {
        case "staff":
          return {
            showUserTab: true,
            showDepartmentTab: true,
            additionalTabs: [
              {
                label: "应用角色",
                value: "role",
                options: [{ id: "100", name: "全部角色" }].concat(
                  this.roles.map(({ id, name }) => ({ id, name }))
                )
              }
            ]
          }
        case "company":
          return {
            showUserTab: false,
            showDepartmentTab: false,
            additionalTabs: [
              {
                label: "企业",
                value: "company",
                options: this.connectedCompanies.map(({ id, name }) => ({ id, name }))
              },
              {
                label: "互联角色",
                value: "companyType",
                options: this.companyTypes.map(({ id, name }) => ({ id, name }))
              }
            ]
          }
        default:
          return {}
      }
    },
    userScopeVarGroup() {
      if (this.editControl._type !== "staff") {
        return []
      }
      let canUseType = ["department", "staff"]
      let varGroup = [this.getVars(this.sheet, canUseType)]
      this.sheet.controls
        .filter(control => control._type === "ref" && control.oneFlag && control._cid)
        .forEach(refControl => {
          if (this.availableSheetMap[refControl.refSheetId]) {
            varGroup.push(
              this.getVars(this.availableSheetMap[refControl.refSheetId], canUseType, refControl)
            )
          }
        })
      return varGroup.filter(i => i.options.length > 0)
    }
  },
  data() {
    return {
      roles: [],
      connectedCompanies: [],
      companyTypes: [],
      loading: false
    }
  },
  created() {
    this.loading = true
    Promise.all([
      getRoles({ appId: this.sheet.appId }).then(roles => (this.roles = roles)),
      getAllConnectedCompany().then(companies => (this.connectedCompanies = companies)),
      getCompanyConnectType({ withNum: false, noCache: false }).then(res => {
        this.companyTypes = res
      })
    ]).then(() => (this.loading = false))
  },
  methods: {
    getVars(sheetDef, canUseType, refControl) {
      let vars = [],
        title = ""
      if (!refControl) title = "自己"
      else title = refControl.name
      sheetDef.controls.forEach(control => {
        // 跳过自身和新建的字段
        if (control._cid === this.editControl._cid || !control._cid) return
        if (canUseType.includes(control._type)) {
          let v = control._cid
          let name = control.name
          if (refControl) v = refControl._cid + "_" + v
          vars.push({
            label: name,
            type: control._type,
            value: "v" + v
          })
        }
      })
      return { title, options: vars }
    }
  }
}
</script>
<style lang="scss" scoped></style>
